import { createFileRoute } from "@tanstack/react-router";
import { OrganizationAdminClassDetailPage } from "./-components/class-detail-page";

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/_classes/classes_/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationId } = Route.useParams();

  return <OrganizationAdminClassDetailPage classId={null} organizationId={organizationId} tab={"details"} />;
}
